module.exports = {
    home: 'Home',
    products: 'Products',
    suggest: 'Advantage',
    process: 'Process',
    sign_in: 'Sign in',
    sign_up: 'Sign up',
}
